import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  Button,
  Autocomplete,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { CountriesData, checkUserLoggedIn } from "../shared/commonfunctions";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./YourProfile.css";
import {
  NRIFATCAAPICall,
  stageDetailsAPICall,
  startOverAPICall,
} from "../shared/APICalls";
import { INRIFATCA, IYourProfilePrefillData } from "../shared/dtos";
import routesData from "../shared/routes.json";
import FatcaStyles from "../pages/Styles/FATCA.module.scss";

import StageLayout from "../Layouts/StageLayout";
import icon from "../Components/assets/Images/iconnew.svg";

import BackDrop from "../Components/BackDrop";

import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import PhoneInput, {
  formatPhoneNumberIntl,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TickCircle from "../Components/assets/Images/tick-circle.svg";
import { Country, State, City } from "country-state-city";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/profileicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";

const schema = Yup.object().shape({
  nationality: Yup.string().required("Nationality  is Required"),

  birthCity: Yup.string()
    .required("Birth City is required")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed"),
  birthCountry: Yup.object().required("Birth Country is required"),
  birthState: Yup.object().required("Birth State is required"),
  taxResidencyCountry: Yup.string().required(
    "Country of tax residency is required"
  ),
  // taxIdNumber: Yup.string().matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid TaxId"),
  taxIdNumber: Yup.string()
    .nullable()
    .transform((value) => (value ? value.toUpperCase() : value))
    .when("taxResidencyCountry", {
      is: (val: string) => val && val !== "United Arab Emirates",
      then: (schema) =>
        schema
          .required("Please Enter Tax ID Number")
          .matches(
            /^[a-zA-Z0-9 ]*$/,
            "Only alphabets, numbers and spaces are allowed"
          )
          .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
          .min(3, "Minimum 3 characters required")
          .max(15, "Maximum 50 characters allowed"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export default function FATCA() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cityList = City.getAllCities();
  const stateList = State.getAllStates();
  //Loaders
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>({
    code: "",
    name: "",
  });

  const [startOverloading, setstartOverloading] = useState(false);

  const [prefillData, setprefillData] = useState<any>({
    nationality: "",
    birthCity: "",
    birthState: null,
    birthCountry: null,
    taxResidencyCountry: "",
    taxIdNumber: "",
    fatcacondition1: false,
    fatcacondition2: false,
  });
  const [CityData, setCityData] = useState([]);
  const [selectedState, setSelectedState] = useState<any>({
    countryCode: "",
    isoCode: "",
    latitude: "",
    longitude: "",
    name: "",
  });
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [taxIdError, setTaxIdError] = useState("");
  const [StatesData, setStatesData] = useState<any>([]);
  const navigationData = routesData;
  const [user, setUser] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    StageDetails();
  }, []);

  const StageDetails = () => {
    let obj: any = {
      stage: "fatca",
    };
    setprefilloading(true);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        setRejectMessage(response.data.data.ErrorMessage);
        const BirthCountry = CountriesData().filter(
          (a: any) => a.name === response.data.data.data.country_of_birth
        );
        const BirthState = stateList.filter(
          (a: any) => a.name === response.data.data.data.state_of_birth
        );
        // console.log("response", BirthState);
        setSelectedCountry(
          BirthCountry.length > 0 ? BirthCountry[0] : { code: "", name: "" }
        );
        setSelectedState(
          response.data.data.data.state_of_birth === "Others"
            ? {
                countryCode: "others",
                isoCode: "others",
                latitude: "others",
                longitude: "others",
                name: "Others",
              }
            : BirthState.length > 0
            ? BirthState[0]
            : {
                countryCode: "",
                isoCode: "",
                latitude: "",
                longitude: "",
                name: "",
              }
        );
        setprefillData({
          nationality: response.data.data.data.Nationality,
          birthCity: response.data.data.data.city_of_birth,
          birthState:
            response.data.data.data.state_of_birth === "Others"
              ? {
                  countryCode: "others",
                  isoCode: "others",
                  latitude: "others",
                  longitude: "others",
                  name: "Others",
                }
              : BirthState[0],
          birthCountry: BirthCountry[0],
          taxResidencyCountry: response.data.data.data.country_of_tax_residency,
          taxIdNumber: response.data.data.data.tax_id_number,
          fatcacondition1: response.data.data.data.fatca_terms_and_conditions,
          fatcacondition2: response.data.data.data.fatca_terms_and_conditions,
        });
        setprefilloading(false);
      })
      .catch((error: any) => {
        setprefilloading(false);
      });
  };

  function submitFatca(data: any) {
    let obj: INRIFATCA = {
      Nationality: data.nationality,
      city_of_birth: data.birthCity,
      state_of_birth: data.birthState.name,
      country_of_birth: data.birthCountry.name,
      country_of_tax_residency: data.taxResidencyCountry,
      tax_id_number:
        data.taxResidencyCountry === "United Arab Emirates"
          ? ""
          : data.taxIdNumber,
      fatca_terms_and_conditions: true,
    };
    setloading(true);
    NRIFATCAAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data);
        const responseData = response.data;
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  }
  useEffect(() => {
    const filteredStates: any = stateList.filter(
      (a: any) => a.countryCode === selectedCountry.code
    );

    setStatesData([
      ...filteredStates,
      {
        countryCode: "others",
        isoCode: "others",
        latitude: "others",
        longitude: "others",
        name: "Others",
      },
    ]);
  }, [selectedCountry]);

  useEffect(() => {
    const filteredCities: any = cityList.filter(
      (a: any) =>
        a.stateCode === selectedState.isoCode &&
        a.countryCode === selectedState.countryCode
    );

    // console.log("filteredStates", filteredCities);
    setCityData(filteredCities);
  }, [selectedState]);

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            setstartOverloading(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };
  const initialValues: any = {
    nationality: prefillData.nationality,
    birthCity: prefillData.birthCity,
    birthCountry: prefillData.birthCountry,
    birthState: prefillData.birthState,
    taxResidencyCountry: prefillData.taxResidencyCountry,
    taxIdNumber: prefillData.taxIdNumber,
    fatcacondition1: prefillData.fatcacondition1,
    fatcacondition2: prefillData.fatcacondition2,
  };

  return (
    <div className={FatcaStyles.mainWrapper}>
      <ErrorSnackBar message={rejectMessage} />
      {backdrop && <StartOverBackDrop />}
      <div className={FatcaStyles.wrapper}>
        <div
          className={FatcaStyles.backTop}
          onClick={() => {
            navigate("/addressDetails");
          }}
        >
          <img src={backicon} />
          <span className={FatcaStyles.backText}>Back</span>
        </div>
        <div className={FatcaStyles.step}>
          <img src={keyboardicon} /> Step 3 of 10
        </div>
        <div className={FatcaStyles.leftContainer}>
          <div className={FatcaStyles.headerSection}>
            <p className={FatcaStyles.signup}>FATCA Declaration</p>
          </div>
          {!prefilloading ? (
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={(values: any) => {
                // console.log("values", values);
                if (values.taxResidencyCountry === "United Arab Emirates") {
                  submitFatca(values);
                } else if (
                  values.taxResidencyCountry?.name !== "United Arab Emirates"
                ) {
                  if (values.taxIdNumber === "") {
                    setTaxIdError("Tax Id cannot be empty");
                    setTimeout(() => {
                      setTaxIdError("");
                    }, 5000);
                  } else {
                    submitFatca(values);
                  }
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              }) => {
                // console.log("values", values);
                // console.log("errors", errors);
                return (
                  <form
                    noValidate
                    onSubmit={handleSubmit}
                    onKeyDown={(event) => {
                      event.code === "Enter" && handleSubmit();

                      // event.code.includes("Enter") && handleSubmit()
                    }}
                  >
                    <div className={FatcaStyles.contentWrapper}>
                      <div className={FatcaStyles.feildwrapper}>
                        <div className={FatcaStyles.topContainer}>
                          <div className={FatcaStyles.textFeildWrapper}>
                            <Autocomplete
                              // size="small"
                              className={FatcaStyles.textfield}
                              options={CountriesData()
                                ?.filter(
                                  (list: any) => list.name !== "Pakistan"
                                )
                                .map((a: any) => a.name)}
                              value={values.nationality}
                              onChange={(event: any, newValue: any) => {
                                setFieldValue("nationality", newValue);
                              }}
                              id="disable-clearable"
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={"Select Nationality"}
                                  inputProps={{
                                    ...params.inputProps,
                                    sx: {
                                      color: "var(--Black-Black-500, #6B7280)",
                                      fontSize: "14px",
                                    },
                                    maxLength: 150,
                                    inputMode: "text",
                                  }}
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                      },
                                    },
                                  }}
                                />
                              )}
                              // renderTags={() => null}
                            />
                          </div>

                          <div className={FatcaStyles.textFeildWrapper}>
                            <Autocomplete
                              // size="small"
                              className={FatcaStyles.textfield}
                              options={CountriesData()
                                ?.filter(
                                  (list: any) => list.name !== "Pakistan"
                                )
                                .map((a: any) => a)}
                              value={values.birthCountry}
                              getOptionLabel={(option) => option.name}
                              onChange={(event: any, newValue: any) => {
                                setFieldValue("birthCountry", newValue);
                                setFieldValue("birthState", null);
                                setFieldValue("birthCity", "");
                                setSelectedCountry(newValue);
                              }}
                              id="disable-clearable"
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={"Select Birth Country"}
                                  inputProps={{
                                    ...params.inputProps,
                                    sx: {
                                      color: "var(--Black-Black-500, #6B7280)",
                                      fontSize: "14px",
                                    },
                                    maxLength: 150,
                                    inputMode: "text",
                                  }}
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                      },
                                    },
                                  }}
                                />
                              )}
                              // renderTags={() => null}
                            />
                          </div>
                        </div>

                        <div className={FatcaStyles.topContainer}>
                          <div className={FatcaStyles.textFeildWrapper}>
                            <Autocomplete
                              // size="small"
                              freeSolo
                              className={FatcaStyles.textfield}
                              options={StatesData.map((a: any) => a)}
                              getOptionLabel={(option) => option.name}
                              value={values.birthState}
                              onChange={(event: any, newValue: any) => {
                                setFieldValue("birthState", newValue);
                                setSelectedState(newValue);
                                setFieldValue("birthCity", "");
                              }}
                              id="disable-clearable"
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={"Select Birth State"}
                                  helperText={
                                    touched.birthState &&
                                    errors.birthState?.toString()
                                  }
                                  error={
                                    touched.birthState &&
                                    Boolean(errors.birthState)
                                  }
                                  inputProps={{
                                    ...params.inputProps,
                                    sx: {
                                      color: "var(--Black-Black-500, #6B7280)",
                                      fontSize: "14px",
                                    },
                                    maxLength: 150,
                                    inputMode: "text",
                                  }}
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                      },
                                    },
                                  }}
                                />
                              )}
                              // renderTags={() => null}
                            />
                          </div>

                          <div className={FatcaStyles.textFeildWrapper}>
                            <Autocomplete
                              // size="small"
                              freeSolo
                              className={FatcaStyles.textfield}
                              options={CityData.map((a: any) => a.name)}
                              // getOptionLabel={(option) => option.name}
                              value={values.birthCity}
                              onInputChange={(event: any, newValue: any) => {
                                setFieldValue("birthCity", newValue);
                              }}
                              id="disable-clearable"
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={"Select Birth City"}
                                  helperText={
                                    touched.birthCity &&
                                    errors.birthCity?.toString()
                                  }
                                  error={
                                    touched.birthCity &&
                                    Boolean(errors.birthCity)
                                  }
                                  inputProps={{
                                    ...params.inputProps,
                                    sx: {
                                      color: "var(--Black-Black-500, #6B7280)",
                                      fontSize: "14px",
                                    },
                                    maxLength: 150,
                                    inputMode: "text",
                                  }}
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                      },
                                    },
                                  }}
                                />
                              )}
                              // renderTags={() => null}
                            />
                          </div>
                        </div>

                        <div className={FatcaStyles.topContainer}>
                          <div className={FatcaStyles.textFeildWrapper}>
                            <Autocomplete
                              // size="small"
                              className={FatcaStyles.textfield}
                              options={CountriesData()
                                ?.filter(
                                  (list: any) => list.name !== "Pakistan"
                                )
                                .map((a: any) => a.name)}
                              // options={CountriesData().map((a: any) => a.name)}
                              value={values.taxResidencyCountry}
                              onChange={(event: any, newValue: any) => {
                                setFieldValue("taxResidencyCountry", newValue);
                              }}
                              id="disable-clearable"
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={"Select Tax Residency Country"}
                                  inputProps={{
                                    ...params.inputProps,
                                    sx: {
                                      color: "var(--Black-Black-500, #6B7280)",
                                      fontSize: "14px",
                                    },
                                    maxLength: 150,
                                    inputMode: "text",
                                  }}
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                      },
                                    },
                                  }}
                                />
                              )}
                              // renderTags={() => null}
                            />
                          </div>
                          {values.taxResidencyCountry !==
                            "United Arab Emirates" && (
                            <div className={FatcaStyles.textFeildWrapper}>
                              <TextField
                                className={FatcaStyles.textfield}
                                id="outlined-basic"
                                label="Tax Identification Number"
                                variant="outlined"
                                name="taxIdNumber"
                                value={
                                  values.taxIdNumber &&
                                  values.taxIdNumber.toUpperCase()
                                }
                                error={
                                  touched.taxIdNumber &&
                                  Boolean(errors.taxIdNumber)
                                }
                                helperText={
                                  touched.taxIdNumber &&
                                  errors.taxIdNumber?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    color: "var(--Black-Black-500, #6B7280)",
                                    fontSize: "14px",
                                  },
                                  maxLength: 30,
                                  inputMode: "text",
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                    },
                                  },
                                }}
                              />
                              <FormHelperText
                                style={{
                                  color: "#ef5350",
                                  textAlign: "left",
                                  width: "100%",
                                }}
                              >
                                {taxIdError}
                              </FormHelperText>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className={FatcaStyles.tablemain}>
                        <div className={FatcaStyles.checkBoxDiv}>
                          <FormGroup>
                            <FormControlLabel
                              sx={{ alignItems: "flex-start" }}
                              control={
                                <Checkbox
                                  name="fatcacondition1"
                                  sx={{ padding: "0px", marginTop: "5px" }}
                                  checked={values.fatcacondition1}
                                  // icon={<PanoramaFishEyeIcon />}
                                  // checkedIcon={
                                  //   <img src={TickCircle} width={"24px"} />
                                  // }
                                  onChange={(event) => {
                                    const { checked } = event.target;

                                    setFieldValue("fatcacondition1", checked);
                                  }}
                                />
                              }
                              label={
                                <span className={FatcaStyles.label}>
                                  <span>
                                    I/We require you to issue Delivery
                                    Instruction Slip (DIS) booklet to me/us
                                    immediately on opening my/our CDSL account
                                    though I/We have issued a Power of Attorney
                                    (POA) in favor of Firstock Broking Pvt Ltd.
                                    for executing delivery instructions for
                                    settling stock exchange trades (Settlement
                                    related transactions) effected through such
                                    Clearing Member.
                                  </span>

                                  {/* basis from my NCO securities trading
                                      account. */}
                                </span>
                              }
                            />
                          </FormGroup>
                        </div>

                        <div className={FatcaStyles.checkBoxDiv}>
                          <FormGroup>
                            <FormControlLabel
                              sx={{ alignItems: "flex-start" }}
                              control={
                                <Checkbox
                                  name="fatcacondition2"
                                  sx={{ padding: "0px", marginTop: "5px" }}
                                  checked={values.fatcacondition2}
                                  // icon={<PanoramaFishEyeIcon />}
                                  // checkedIcon={
                                  //   <img src={TickCircle} width={"24px"} />
                                  // }
                                  onChange={(event) => {
                                    const { checked } = event.target;

                                    setFieldValue("fatcacondition2", checked);
                                  }}
                                />
                              }
                              label={
                                <span className={FatcaStyles.label}>
                                  <span>
                                    {" "}
                                    I/We do not require Delivery Instruction
                                    Slip (DIS) for the time being. Since I/We
                                    have issued a POA/EDIS in favor of Firstock
                                    Broking Pvt Ltd. for executing delivery
                                    instructions for settling stock exchange
                                    trades (Settlement related transactions)
                                    effected through such Clearing Member.
                                    However, the Delivery Instruction Slip (DIS)
                                    booklet should be issued to me/us
                                    immediately on my/our request at any later
                                    date.
                                  </span>

                                  {/* basis from my NCO securities trading
                                      account. */}
                                </span>
                              }
                            />
                          </FormGroup>
                        </div>
                      </div>

                      <div className={FatcaStyles.buttonStack}>
                        {values.nationality &&
                        values.birthCity &&
                        values.birthCountry.name &&
                        values.taxResidencyCountry &&
                        values.birthState &&
                        // values.taxIdNumber &&
                        values.fatcacondition1 &&
                        values.fatcacondition2 ? (
                          <LoadingButton
                            loading={loading}
                            variant="contained"
                            type="submit"
                            id="yourProfileContinueButton"
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={FatcaStyles.approveButton}
                            sx={{ height: "50px" }}
                          >
                            Continue
                          </LoadingButton>
                        ) : (
                          <Button
                            variant="contained"
                            disabled
                            sx={{ height: "50px" }}
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={FatcaStyles.approveButton}
                          >
                            Continue
                          </Button>
                        )}

                        {/* <div className={FatcaStyles.startOverSection}>
                          <img src={icon} className={FatcaStyles.iconImage} />
                          <p className={FatcaStyles.paratext}>
                            {" "}
                            if the above mentioned info not yours
                            <span
                              className={FatcaStyles.startoverbutton}
                              onClick={handleStartOver}
                            >
                              Start Over
                            </span>
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </form>
                );
              }}
            </Formik>
          ) : (
            <div style={{ height: "80vh" }}>
              <BackDrop />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
